// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buybox-row[data-v-46188996]{background:hsla(0,0%,100%,.0392156863)}", ""]);
// Exports
module.exports = exports;
